import { usePermission } from '@/hooks/usePermission';
import { VoiceLibraryPanel } from '@/resources/livestreams/components/VoiceLibraryPanel';

/**
 * Страница «Голоса» в разделе AI.
 *
 * Библиотека общая для всех эфиров, поэтому живёт отдельным разделом,
 * а не только внутри конкретной трансляции. На странице эфира та же
 * панель показывается рядом с выбором голоса спикера.
 */
export function VoiceProfilesList() {
  const { hasPermission: canEdit } = usePermission('livestreams.update');

  return (
    <div className="space-y-4 p-4">
      <div>
        <h1 className="text-2xl font-semibold">Голоса</h1>
        <p className="text-sm text-muted-foreground">
          Голоса, которыми звучит перевод эфиров. Образец можно взять из урока курса или
          загрузить записью.
        </p>
      </div>

      <VoiceLibraryPanel canEdit={canEdit} />
    </div>
  );
}
